// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"44":"01956642","57":"1e839f69","58":"7ce39d7a","222":"6b712982","270":"f8572b5e","404":"6e9d5b8b","410":"21faf02c","512":"5f93c512","645":"893aaf8b","671":"6a85844c","702":"b11049d2","738":"f4b9cdca","887":"19ded9cc"}[chunkId] + ".chunk.js";
};